import $ from 'jquery';

$(document).ready(function () {
  acfTitleBlock();
});

function acfTitleBlock() {
  $('.js-acf-title-block').each(function () {});
}
